import { configureStore } from "@reduxjs/toolkit";
import GuideReducer from "./features/GuideSlice";
import NavBarRuducer from "./features/NavBarSlice";
import responsiveReducer from "./features/ResponsiveSlice";

const store = configureStore({
  reducer: {
    guide: GuideReducer,
    nav: NavBarRuducer,
    responsive: responsiveReducer,
  },
});

export default store;
